const CopyRight = () => {
  return (
    <div className="copy-right-wrapper">
      <div className="copy-right">
        <a
          className="isometric-link"
          href="https://www.freepik.com/free-vector/computer-technology-isometric-icon-server-room-digital-device-set-element-design-pc-laptop_4103157.htm#query=isometric&position=0&from_view=search&track=sph"
        >
          © Isometric image designed by fullvector / Freepik
        </a>
        <br />
        <a
          className="teko-font-link"
          href="https://fonts.google.com/specimen/Teko"
        >
          © Thanks google fonts - The font Teko designed by Indian Type Foundry
        </a>
      </div>
    </div>
  );
};
export default CopyRight;
